import { getCheckoutItems } from 'api/checkoutApi';

export const LOADING_PRICE_PLANS_START = 'LOADING_PRICE_PLANS_START';
export const LOADING_PRICE_PLANS_SUCCESS = 'LOADING_PRICE_PLANS_SUCCESS';
export const LOADING_PRICE_PLANS_FAILED = 'LOADING_PRICE_PLANS_FAILED';

export const loadingPricePlansStartAction = () => {
  return {
    type: LOADING_PRICE_PLANS_START,
  };
};

export const loadingPricePlansSucessAction = items => {
  return {
    type: LOADING_PRICE_PLANS_SUCCESS,
    payload: items,
  };
};

export const loadingPricePlansFailedAction = e => {
  return {
    type: LOADING_PRICE_PLANS_FAILED,
    payload: e,
  };
};

export const getAllPricePlans = () => async dispatch => {
  const calculateDiscountedPrice = originalPrice => {
    // Assuming you want the price as a string with 2 decimal places
    const discountedPrice = (originalPrice * 2).toFixed(0);
    return discountedPrice;
  };

  try {
    dispatch(loadingPricePlansStartAction());
    //const timezone = isOffer ? 'Asia/Calcutta' : Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const response = await getCheckoutItems({ locale: timezone });
    const items = response.data;
    //const items = mockPricePlans;

    console.log('priceList', items);

    const processedItems = items.map(item => {
      const originalPrice = +item.price;
      const discount = originalPrice.toFixed(0);
      return {
        ...item,
        price: discount,
        priceOld: calculateDiscountedPrice(originalPrice),
        originalPrice: originalPrice.toFixed(0),
      };
    });

    dispatch(loadingPricePlansSucessAction(processedItems));
  } catch (error) {
    dispatch(loadingPricePlansFailedAction(error.message || 'Failed to load price plans'));
  }
};
